import { useMutation } from '@tanstack/react-query';

import { StoreApi } from '../../api';
import type { ConsumerCreateCheckoutCartResponse } from './checkout.types';

type ConsumerCheckoutCartRequest = {
  checkout: {
    /** If pending carts are supplied, they'll be available on the show request if cart_ids are not supplied */
    pending_cart_ids: string[];
  };
};

/** Creates a new checkout Object */
const useCreateConsumerCheckout = () => {
  const createConsumerCheckoutCart = async (consumerCheckoutCart: ConsumerCheckoutCartRequest) => {
    const { data } = await StoreApi.post<ConsumerCreateCheckoutCartResponse>(
      '/consumer/checkouts',
      consumerCheckoutCart
    );
    return data;
  };

  return useMutation({
    mutationFn: createConsumerCheckoutCart,
  });
};

type ConsumerCheckoutStudentFeesRequest =
  | {
      /** If included, will only create a checkout for the student fees with the given ids */
      student_id?: string;
    }
  | undefined;

const useCreateConsumerStudentFeeCheckout = () => {
  const createConsumerCheckoutStudentFees = async (
    consumerCheckoutStudentFees: ConsumerCheckoutStudentFeesRequest = {}
  ) => {
    const { data } = await StoreApi.post<ConsumerCreateCheckoutCartResponse>(
      '/consumer/student_fees/pay_now',
      consumerCheckoutStudentFees
    );
    return data;
  };
  return useMutation({
    mutationFn: createConsumerCheckoutStudentFees,
  });
};
export { useCreateConsumerCheckout, useCreateConsumerStudentFeeCheckout };
